/**
 * Simple tool which closes the overlay when delay is reached
 */

module.exports = function (app) {
  app.registerComponent('overlay_autoclose', '.js-overlay-autoclose', function (sb, el) {

    var closeDelay = 5000;
    var triggerTimer;
    var onTrigger = function() {
        sb.publish('overlay/hide')
    }


    /* INIT ------------------------------------------- */
    return {
      init: function () {
        closeDelay = el.getAttribute('data-delay');
        triggerTimer = setTimeout(onTrigger, closeDelay)
      },
      destroy: function () {
        clearTimeout(triggerTimer);
      }
    }
  })
}



// WEBPACK FOOTER //
// ./assets/js/components/overlay-autoclose.js